const SuperDTMHandler = require('dgad-analytics-bundle/lib/modules/dgad-analytics/src/adobe/DTMHandler.class')
const DTMSession = require('dgad-analytics-bundle/lib/modules/dgad-analytics/src/adobe/DTMSession.class')
const { SECTIONS_PATHS, TAG_PATHS } = require('./lib/datalayer-paths')

/**
 * Handler for Adobe DTM analytics,
 * with BFG-specific methods.
 */
class DTMHandler extends SuperDTMHandler {
  /**
   * Add page load time to Data Layer and
   * clean its sections during initialization.
   * @override
   */
  init () {
    super.init()
    this.addLoadTime(TAG_PATHS.LOAD_TIME)
    this.cleanDataLayerSections()
  }

  /**
   * Add tags stored in session to Data Layer.
   * @override
   */
  addSessionData () {
    const storedDataLayer = DTMSession.retrieve()
    const storedEventNames = storedDataLayer.get(TAG_PATHS.EVENT_NAMES)

    // Concat event names in order to avoid stored ones to replace data layer's
    if (storedEventNames) {
      const eventNames = this.dataLayer.get(TAG_PATHS.EVENT_NAMES)
      storedDataLayer.set(TAG_PATHS.EVENT_NAMES, `${eventNames},${storedEventNames}`)
    }

    this.dataLayer.merge(storedDataLayer)
    DTMSession.delete()
  }

  /**
   * Clean pageInfo and eventInfo sections.
   */
  cleanDataLayerSections () {
    this.dataLayer.clean([ SECTIONS_PATHS.PAGE_INFO, SECTIONS_PATHS.EVENT_INFO ])
  }
}

module.exports = DTMHandler



// WEBPACK FOOTER //
// ./lib/modules/dgad-analytics/src/adobe/DTMHandler.class.js